export enum SpaceEvents {
  AfterAllServicesInitialized = 'afterAllServicesInitialized',
  AfterEntitiesCreated = 'afterEntitiesCreated',
  BeforeBaseServicesBuilt = 'BeforeBaseServicesBuilt',
  BeforeEntitiesCreated = 'beforeEntitiesCreated',
  BeforeResourcesLoaded = 'beforeResourcesLoaded',
  BeforeEntitiesServicesBuilt = 'beforeEntitiesServicesBuilt',
  BeforeLoopsCreated = 'beforeLoopsCreated'
}
